module.exports = __webpack_public_path__ + "img/baht-sign.67a3bf46.svg";